/**
 * A `JSON.stringify` replacer function to stringify URLSearchParams.
 * @param _ Ignored key.
 * @param value Value of the property.
 */
export const urlSearchParamsReplacer = (_: PropertyKey, value: unknown) =>
	value instanceof URLSearchParams ? [...value.entries()] : value;
